// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для страницы сервисов */
.Installation_service-page__n8tOi {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.Installation_service-title__eecmV {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2.5rem;
  color: #333;
}

.Installation_service-content__4rRdX {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.Installation_service-description__l1ZKf {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: #444;
}

.Installation_service-features__MvRXJ {
  margin-bottom: 2rem;
}

.Installation_service-features__MvRXJ h2 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #333;
}

.Installation_service-features__MvRXJ ul {
  list-style-type: none;
  padding-left: 0;
}

.Installation_service-features__MvRXJ li {
  padding: 0.8rem 0;
  padding-left: 2rem;
  position: relative;
  font-size: 1.1rem;
}

.Installation_service-features__MvRXJ li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #007bff;
  font-weight: bold;
}

.Installation_service-image__6M1xC {
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.Installation_service-image__6M1xC img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

.Installation_service-image__6M1xC img:hover {
  transform: scale(1.02);
}

.Installation_service-cta__hq0rx {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-top: 2rem;
  text-align: center;
}

.Installation_service-cta__hq0rx h3 {
  margin-bottom: 1rem;
  color: #333;
}

.Installation_contact-button__JP7BM {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 1rem;
}

.Installation_contact-button__JP7BM:hover {
  background-color: #0056b3;
}

/* Медиа-запросы для адаптивности */
@media (min-width: 768px) {
  .Installation_service-content__4rRdX {
    flex-direction: row;
    align-items: flex-start;
  }
  
  .Installation_service-info__yEzC9 {
    flex: 1 1;
    padding-right: 2rem;
  }
  
  .Installation_service-image__6M1xC {
    flex: 1 1;
    max-width: 500px;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/Services/Installation/Installation.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;AACF","sourcesContent":["/* Стили для страницы сервисов */\n.service-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n}\n\n.service-title {\n  text-align: center;\n  margin-bottom: 2rem;\n  font-size: 2.5rem;\n  color: #333;\n}\n\n.service-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.service-description {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  color: #444;\n}\n\n.service-features {\n  margin-bottom: 2rem;\n}\n\n.service-features h2 {\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.service-features ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.service-features li {\n  padding: 0.8rem 0;\n  padding-left: 2rem;\n  position: relative;\n  font-size: 1.1rem;\n}\n\n.service-features li::before {\n  content: \"✓\";\n  position: absolute;\n  left: 0;\n  color: #007bff;\n  font-weight: bold;\n}\n\n.service-image {\n  width: 100%;\n  overflow: hidden;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.service-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  transition: transform 0.3s ease;\n}\n\n.service-image img:hover {\n  transform: scale(1.02);\n}\n\n.service-cta {\n  background-color: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.service-cta h3 {\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.contact-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 0.8rem 1.5rem;\n  font-size: 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  margin-top: 1rem;\n}\n\n.contact-button:hover {\n  background-color: #0056b3;\n}\n\n/* Медиа-запросы для адаптивности */\n@media (min-width: 768px) {\n  .service-content {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n  \n  .service-info {\n    flex: 1;\n    padding-right: 2rem;\n  }\n  \n  .service-image {\n    flex: 1;\n    max-width: 500px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"service-page": `Installation_service-page__n8tOi`,
	"service-title": `Installation_service-title__eecmV`,
	"service-content": `Installation_service-content__4rRdX`,
	"service-description": `Installation_service-description__l1ZKf`,
	"service-features": `Installation_service-features__MvRXJ`,
	"service-image": `Installation_service-image__6M1xC`,
	"service-cta": `Installation_service-cta__hq0rx`,
	"contact-button": `Installation_contact-button__JP7BM`,
	"service-info": `Installation_service-info__yEzC9`
};
export default ___CSS_LOADER_EXPORT___;
